export default __webpack_public_path__ + "static/media/divider.f3e022b6.svg";